const init = (settings) => {
    let options = {
        accordionToggleSelector: "[js-accordion]"
    };
    const menuToggle = document.querySelectorAll(options.accordionToggleSelector);

    for(let i = 0; i < menuToggle.length; i++) {
        menuToggle[i].querySelector('.accordion__title').addEventListener('click', (e) => {
            e.preventDefault();
            if (menuToggle[i].classList.contains('open')) {
                menuToggle[i].classList.remove('open');
            } else  {
                menuToggle[i].classList.add('open');
            }
        });
    }
};

export default {
    init
}
